<template>
  <div>
    <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
      <p v-for="error in errors" class="errors">
        {{ error }}
      </p>
    </div>
    <div>
      Set the {{ partnerLabel.toLowerCase() }}'s status to
      <span :class="{'has-error':errors.status}">
        <select :value="status" name="status" class="form-control" @change="handleChange">
          <option value="" disabled>Select one</option>
          <option value="Active">Active</option>
          <option value="Disabled">Disabled</option>
        </select>
      </span>
    </div>
  </div>
</template>

<script>
import BaseComponent from '@/EventLogic/components/BaseComponent.vue';
import {enumValidator} from "@/EventLogic/util";

export default {
  extends: BaseComponent,
  props: {
    id: String,
    status: {
      type: String,
      validator: enumValidator(['Active', 'Disabled'])
    },
  },
  computed: {
    partnerLabel() {
      return this.config.supportPartnerLabel;
    },
  },
  methods: {
    validate: function() {
      this.errors = {};

      if (!this.status) {
        this.errors.status = "Please select a status.";
      }

      return Object.keys(this.errors).length === 0;
    }
  }
};
</script>
